// extracted by mini-css-extract-plugin
module.exports = {"CandidateResumeSkills__description":"CandidateResumeSkills_CandidateResumeSkills__description__x_XHq"};